import { Box, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import ContractActivationDate from './ContractActivationDate'
import EmployeeOnboardingCard from './EmployeeOnboardingCard'
import Warning from './Warning'

interface Props {
  nextAvailableDate: string
  activityResumeDate: string
  setActivityResumeDate: (value: string) => void
  onboardingEnabled: boolean
  setOnboardingEnabled: (value: boolean) => void
  selectedWorkflow?: string | number
  setSelectedWorkflow: (value: string | undefined) => void
  isDisabled?: boolean
  error?: string
  isOpen?: boolean
  onToggle?: (isOpen: boolean) => void
  mandatory?: boolean
  unTerminateImmediately: boolean
  setUnTerminateImmediately: (value: boolean) => void
}

const EnableAccessCard = ({
  open,
  onChange,
  title,
  description,
}: {
  open: boolean
  title: string
  description: string
  onChange: () => void
}) => {
  return (
    <Box textAlign="left" gap="s8">
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s16" alignItems="center">
        <Box style={{ maxWidth: '90%' }} flexDirection="row" alignItems="center" gap="s8">
          <Text.Normal weight="medium" lineClamp={3} color="grey1000">
            {title}
          </Text.Normal>
        </Box>
        <TogglerCheckbox value={open} onChange={onChange} />
      </Box>
      <Box flexDirection="row" alignItems="center">
        {description && (
          <Text.Normal color="grey800" size="200" lineClamp={3}>
            {description}
          </Text.Normal>
        )}
      </Box>
    </Box>
  )
}

const FirstStep = ({
  nextAvailableDate,
  activityResumeDate,
  setActivityResumeDate,
  onboardingEnabled,
  setOnboardingEnabled,
  selectedWorkflow,
  setSelectedWorkflow,
  isDisabled,
  error,
  isOpen,
  onToggle,
  mandatory,
  unTerminateImmediately,
  setUnTerminateImmediately,
}: Props) => {
  return (
    <>
      <ContractActivationDate
        value={activityResumeDate}
        onChange={setActivityResumeDate}
        nextAvailableDate={nextAvailableDate}
      />

      <FormRow>
        <Box
          padding="s16"
          borderRadius={{ all: 'abs008' }}
          style={{
            backgroundColor: 'white',
            border: '1px solid #E0E0E0',
          }}
        >
          <EnableAccessCard
            open={unTerminateImmediately}
            onChange={() => setUnTerminateImmediately(!unTerminateImmediately)}
            title={i18n.t('contract_versions.header.pause_resume.resume_modal.enable_access_title')}
            description={i18n.t(
              'contract_versions.header.pause_resume.resume_modal.enable_access_description'
            )}
          />
        </Box>
      </FormRow>

      <EmployeeOnboardingCard
        enabled={onboardingEnabled}
        onChange={setOnboardingEnabled}
        selectedWorkflow={selectedWorkflow}
        onWorkflowSelect={setSelectedWorkflow}
        isDisabled={isDisabled}
        error={error}
        isOpen={isOpen}
        onToggle={onToggle}
        mandatory={mandatory}
      />

      <Warning />
    </>
  )
}

export default FirstStep
